$( document ).ready(function() {
  $('.single-slider .slide-list').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: true,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

  $('.product-slider .product-list').slick({
      rows: 3,
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
     {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 801,
        settings: {          
          rows:5,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  
 $('.pro-mobile-slider .featured-list').slick({      
      rows: 4,
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 641,
          settings: {            
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
  });

  $('.customer-slider .customer-list').slick({
      dots: false,
      arrows: true,
      infinite: true,
      centerMode: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 801,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  $('.reviews-slider .reviews-list').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
          breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
        {
        breakpoint: 801,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
       {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }  
    ]
  });
  
  $('.featured-slider .featured-list').slick({
      rows: 2,
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },  
      {
        breakpoint: 1024,
        settings: {          
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
        {
        breakpoint: 801,
        settings: {
          rows: 3,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });  


   
  


// $(function(){
//   var $modal = $('.embed-container');
//   var HIDE_CLASS = 'is-hide';
  
//   $('#center-img-main').on('click',function(){
//     $modal.removeClass(HIDE_CLASS);
//   });
  
//   $('.js-modal-close').on('click',function(){
//     $modal.addClass(HIDE_CLASS);
//   });
  // });
  
  $(document).on('click',".jdgm-prev-badge", function(e) {
    e.preventDefault();
    $('.description_tab .tabs a').get(1).click();
    $('html, body').animate({
      scrollTop: $(".product_description_sec").offset().top
    }, 2000);
  });

});




$(document).ready(function () {
  // Main Image Slider
  $('.custom-main-image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.custom-thumbnail'
  });

  // Thumbnail Slider
  $('.custom-thumbnail').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.custom-main-image',
    dots: false,
    arrows: true,
    focusOnSelect: true,
    infinite: true,
    speed: 300,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
});



$(".select_tabs").click(function() {
  $(this).toggleClass("open");
  });
  $(".select_tabs li").click(function() {
  
    var selected_value = $(this).html();
    var first_li = $(".select_tabs li:first-child").html();
  
    $(".select_tabs li:first-child").html(selected_value);
    $(this).html(first_li);
  
  });
  
  $(document).mouseup(function(event) {
    var target = event.target;
    var select = $(".select_tabs");
    if (!select.is(target) && select.has(target).length === 0) {
      select.removeClass("open");
    }

});



// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});


/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.product-list').slick('refresh');
});

/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

  $('.product-list').slick('refresh');
});



// sort by dropdown event start
// const sortSelectElm = document.querySelector(".js-sort-by-event");
// if (sortSelectElm) {
//   $('.js-sort-by-event').on('change', function() {
//   const selectedValue = $(this).val();
//   console.log(selectedValue)
//   if (selectedValue) {
//     $(`input[type="radio"][name="sort_by"][value="${selectedValue}"]`)
//       .prop('checked', true)
//       .trigger('change'); // Optional: trigger change event if needed
//   }
// });

  // sortSelectElm.addEventListener("change", function(event) {
  //   const selectedValue = event.target.value;
  //   const modalRadios = document.querySelectorAll(".js-modal-select-main input[type='radio']");

  //   let found = false;
  //   modalRadios.forEach(radio => {
  //     if (radio.value === selectedValue && !found) {
  //       if (!radio.checked) {
  //         // Update checked state
  //         radio.checked = true;
          
  //   console.log("Selected radio:", selectedValue);
  //         // Create and dispatch change event
  //         const changeEvent = new Event('change', {
  //           bubbles: true,
  //           cancelable: true
  //         });
  //         radio.dispatchEvent(changeEvent);
  //       }
  //       found = true; // Stop after first match
  //     }
  //   });

  // });
//}
document.addEventListener("DOMContentLoaded", function () {
  const sortSelectElm = document.querySelector(".js-sort-by-event");
  const triggerDiv = document.querySelector('[data-aid="sort-topbar-trigger"]');
  //console.log(tiggerCloseDiv);
  if (triggerDiv) {
    triggerDiv.click(); // This simulates a click on the div
      const closeButtons = document.querySelectorAll('button[data-armada-selector-alt="modal-close-button"]');
      closeButtons.forEach(function(button) {
        button.click(); // Simulates a user clicking the close button
      });
  }
  if (sortSelectElm) {
    sortSelectElm.addEventListener("change", function () {
      const selectedValue = this.value;
      console.log("Selected value:", selectedValue);

      if (selectedValue) {
        const radioInput = document.querySelector(`input[type="radio"][name="sort_by"][value="${selectedValue}"]`);
        const radioLabel = document.querySelector(`label[for="${radioInput?.id}"]`);
        console.log("Radio found:", radioLabel);

        if (radioLabel) {
          radioLabel.click();
        } else if (radioInput) {
          radioInput.click();
          radioInput.checked = true;
          radioInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });
  }
});

// sort by dropdown event end


 var url = window.location.href;
 var parts = url.split("/");
 var lastPart = parts[parts.length - 1];
 if (lastPart.includes("?")) {
     var queryIndex = lastPart.indexOf("?");
     lastPart = lastPart.substring(0, queryIndex);
 }
 var product_handle = lastPart;

jQuery(document).ready(function($) {
  $('[data-name="product-option-select"]').on('change', function() {
    var selectedOptions = [];
    $('[data-name="product-option-select"]').each(function() {
      selectedOptions.push($(this).find("option:selected").text().trim());
    });
    var optionsTitle = selectedOptions.join(" / "); // Match Shopify variant title format
            console.log(optionsTitle,'no')

    $.getJSON(window.Shopify.routes.root + "products/" + product_handle + ".js", function(product) {
      var variants = product.variants;
      $.each(variants, function(index, variant) {
        if (variant.title === optionsTitle) {
          if (variant.featured_image) {
            $(".custom-main-image .custom-main-image-inner img").attr("srcset", variant.featured_image.src);
            $('.custom-main-image').slick('slickGoTo', variant.position - 1);
          }
        }
      });
    });
  });
});

